import UserProfileContainer from "@/components/UserProfileContainer";
import { Avatar, Box, Drawer } from "@mui/material";
import { useState } from "react";

export default function UserProfileDrawer({
  userKey,
  userProfile,
  avatarSize = 34,
}) {
  const [open, setOpen] = useState(false);

  return (
    <Box>
      <Avatar
        src={userProfile}
        sx={{ width: avatarSize, height: avatarSize }}
        onClick={() => setOpen(true)}
      />
      {open && (
        <Drawer
          anchor="bottom"
          open={open}
          onClose={() => setOpen(!open)}
          elevation={5}
          sx={{
            "& .MuiDrawer-paper": {
              borderRadius: "20px 20px 0 0",
            },
          }}
        >
          <UserProfileContainer userKey={userKey} />
        </Drawer>
      )}
    </Box>
  );
}
